interface ILoginHTMLElements {
  forgottenPasswordForm: HTMLElement
}

interface ILoginNodeLists {
  forgottenPasswordBtns: NodeList
}

interface ILoginSelectors {
  forgottenPasswordBtn: string,
  forgottenPasswordForm: string
}

interface ILoginConfig {
  htmlElements: ILoginHTMLElements,
  nodeLists: ILoginNodeLists,
  selectors: ILoginSelectors
}

class Login {
  private config: ILoginConfig;

  constructor() {
    this.config = {
      htmlElements: {
        forgottenPasswordForm: null
      },
      nodeLists: {
        forgottenPasswordBtns: null
      },
      selectors: {
        forgottenPasswordBtn: '[data-forgotten-password-btn]',
        forgottenPasswordForm: '[data-forgotten-password-form]'
      }
    }
  }

  init() {
    this.load();
    this.addEventListeners();
  }

  load() {
    this.config.nodeLists.forgottenPasswordBtns = document.querySelectorAll(this.config.selectors.forgottenPasswordBtn);
    this.config.htmlElements.forgottenPasswordForm = document.querySelector(this.config.selectors.forgottenPasswordForm);
  }

  addEventListeners() {
    this.config.nodeLists.forgottenPasswordBtns.forEach((htmlElement: HTMLElement) => htmlElement.addEventListener('click', this.handleForgottenPasswordBtnClick.bind(this)))
  }

  handleForgottenPasswordBtnClick() {
    this.config.htmlElements.forgottenPasswordForm.classList.toggle('hide');
  }
}

export default new Login();